import { add } from '../store/messages/systemMessages/actions';

export function listenForUpdates(dispatch) {
  function actionUpdate(e) {
    if (e.detail.body === 'An update is available.  Tap here to reload.') {
      // this is a system update ready and waiting
      dispatch(add({ type: 'updateReady' }));
    }
  }

  document.addEventListener('system', actionUpdate);
  return actionUpdate;
}

export default function startListeners(store) {
  listenForUpdates(store.dispatch);
}



// WEBPACK FOOTER //
// ./src/lib/attachEventListeners.js